/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPortalSessionLinkResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type PortalSessionLinkResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/subscriptions/portal-session-link
 */
export interface PortalSessionLinkRequestBuilder extends BaseRequestBuilder<PortalSessionLinkRequestBuilder> {
    /**
     * A one-time link into Stripe's billing portal for this organization, where a customer manages their payment method, invoices and cancellation.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PortalSessionLinkResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<PortalSessionLinkResponse | undefined>;
    /**
     * A one-time link into Stripe's billing portal for this organization, where a customer manages their payment method, invoices and cancellation.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const PortalSessionLinkRequestBuilderUriTemplate = "{+baseurl}/api/organizations/subscriptions/portal-session-link";
/**
 * Metadata for all the requests in the request builder.
 */
export const PortalSessionLinkRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: PortalSessionLinkRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPortalSessionLinkResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
